module.exports = __webpack_public_path__ + "media/components/assets/cloth_01-cfdb643caf991feefd514d668d3c8c2b.png";